const colors = {
  white: '#FFFFFF',
  background: '#FAFAFA',
  blue: '#3f51b5',
  errorRed: '#f44336',
  text: '#333333',
  secondaryText: '#666666',
  fieldHover: '#999999',
  hoverMenu: '#F2F3F9',
  tab: {
    text: '#666666',
    background: '#FFFFFF',
    hover: '#E7E7E7',
    selected: {
      text: '#333333',
      background: '#F2F3F9',
    },
  },
  buttons: {
    blueBg: 'rgba(33, 150, 243, 0.2)',
    blueBorder: '#3164D5',
    redBg: 'rgba(220, 55, 44, 0.2)',
    redBorder: '#DC372C',
    activeColor: '#333333',
    containedBg: '#3164D5',
    white: '#FFFFFF',
    lightHover: '#E7E7E7',
  },
};

export default colors;
